
// src/components/GoogleSignIn.js
import React, { useEffect } from "react";

const GoogleSignIn = () => {
    useEffect(() => {
    /* global google */
    window.onload = () => {
        google.accounts.id.initialize({
            client_id: "875910710143-4a6lbl4hbs40s92o98rjdt0ch4i6tr9h.apps.googleusercontent.com",
            callback: handleCredentialResponse,
        });

        google.accounts.id.renderButton(
            document.getElementById("google-signin-button"),
            { theme: "outline", size: "large" }
        );

        google.accounts.id.prompt(); // Opcional: muestra el prompt automático
    };
}, []);

const handleCredentialResponse = (response) => {
console.log("JWT Token:", response.credential);
// Aquí puedes enviarlo a tu backend para verificarlo
};

    return <div id="google-signin-button"></div>;
};

export default GoogleSignIn;
